<div class="homepage">
  <section class="hero">
    <div class="hero-copy">
      <p class="section-kicker public-page-kicker">{{ 'home.hero.eyebrow' | translate }}</p>
      <h1>{{ 'home.hero.title' | translate }}</h1>
      <p class="hero-subtitle">{{ 'home.hero.subtitle' | translate }}</p>

      <div class="hero-badges">
        <span class="hero-badge">{{ 'home.hero.badges.individuals' | translate }}</span>
        <span class="hero-badge">{{ 'home.hero.badges.teams' | translate }}</span>
        <span class="hero-badge">{{ 'home.hero.badges.embed' | translate }}</span>
      </div>

      <div class="hero-actions">
        <button class="btn btn-primary public-page-button public-page-button--primary" [routerLink]="['/sign-up-business']" type="button">
          {{ 'home.hero.primary_cta' | translate }}
        </button>
      </div>
    </div>

    <div class="hero-visual">
      <div class="hero-image-card">
        <img src="/assets/home/app-calendar-week.png" width="2560" height="1600" [attr.alt]="'home.hero.image_alt' | translate">
      </div>

      <div class="phone-frame hero-phone">
        <img src="/assets/home/app-phone-calendar.png" width="780" height="1688" [attr.alt]="'home.hero.phone_image_alt' | translate">
      </div>

      <div class="floating-card floating-card--left">
        <span>{{ 'home.hero.highlight.left.kicker' | translate }}</span>
        <strong>{{ 'home.hero.highlight.left.title' | translate }}</strong>
        <p>{{ 'home.hero.highlight.left.description' | translate }}</p>
      </div>

      <div class="floating-card floating-card--right">
        <span>{{ 'home.hero.highlight.right.kicker' | translate }}</span>
        <strong>{{ 'home.hero.highlight.right.title' | translate }}</strong>
        <p>{{ 'home.hero.highlight.right.description' | translate }}</p>
      </div>
    </div>
  </section>

  <section class="capabilities">
    <div class="section-heading">
      <p class="section-kicker public-page-kicker">{{ 'home.capabilities.eyebrow' | translate }}</p>
      <h2>{{ 'home.capabilities.title' | translate }}</h2>
      <p>{{ 'home.capabilities.description' | translate }}</p>
    </div>

    <div class="capability-grid">
      <article class="capability-card">
        <div class="capability-media">
          <img src="/assets/home/feature-individual.png" width="1440" height="810" loading="lazy" [attr.alt]="'home.capabilities.items.1.alt' | translate">
        </div>
        <h3>{{ 'home.capabilities.items.1.title' | translate }}</h3>
        <p>{{ 'home.capabilities.items.1.description' | translate }}</p>
      </article>

      <article class="capability-card">
        <div class="capability-media">
          <img src="/assets/home/feature-team.png" width="1472" height="828" loading="lazy" [attr.alt]="'home.capabilities.items.2.alt' | translate">
        </div>
        <h3>{{ 'home.capabilities.items.2.title' | translate }}</h3>
        <p>{{ 'home.capabilities.items.2.description' | translate }}</p>
      </article>

      <article class="capability-card">
        <div class="capability-media">
          <img src="/assets/home/feature-availability.png" width="1580" height="888" loading="lazy" [attr.alt]="'home.capabilities.items.3.alt' | translate">
        </div>
        <h3>{{ 'home.capabilities.items.3.title' | translate }}</h3>
        <p>{{ 'home.capabilities.items.3.description' | translate }}</p>
      </article>

      <article class="capability-card">
        <div class="capability-media">
          <img src="/assets/home/feature-brand.png" width="1888" height="1062" loading="lazy" [attr.alt]="'home.capabilities.items.4.alt' | translate">
        </div>
        <h3>{{ 'home.capabilities.items.4.title' | translate }}</h3>
        <p>{{ 'home.capabilities.items.4.description' | translate }}</p>
      </article>
    </div>
  </section>

  <section class="audience">
    <div class="section-heading section-heading--left">
      <p class="section-kicker public-page-kicker">{{ 'home.audience.eyebrow' | translate }}</p>
      <h2>{{ 'home.audience.title' | translate }}</h2>
      <p>{{ 'home.audience.description' | translate }}</p>
    </div>

    <div class="audience-shell">
      <div class="audience-copy">
        <div class="audience-switch">
          <button
            type="button"
            class="audience-switch__button"
            [class.audience-switch__button--active]="activeAudience === 'individual'"
            (click)="setAudience('individual')">
            {{ 'home.audience.individual.tab' | translate }}
          </button>
          <button
            type="button"
            class="audience-switch__button"
            [class.audience-switch__button--active]="activeAudience === 'team'"
            (click)="setAudience('team')">
            {{ 'home.audience.team.tab' | translate }}
          </button>
        </div>

        <div *ngIf="activeAudience === 'individual'; else teamAudience" class="audience-panel">
          <h3>{{ 'home.audience.individual.title' | translate }}</h3>
          <p>{{ 'home.audience.individual.description' | translate }}</p>
          <ul>
            <li>{{ 'home.audience.individual.points.1' | translate }}</li>
            <li>{{ 'home.audience.individual.points.2' | translate }}</li>
            <li>{{ 'home.audience.individual.points.3' | translate }}</li>
          </ul>
        </div>

        <ng-template #teamAudience>
          <div class="audience-panel">
            <h3>{{ 'home.audience.team.title' | translate }}</h3>
            <p>{{ 'home.audience.team.description' | translate }}</p>
            <ul>
              <li>{{ 'home.audience.team.points.1' | translate }}</li>
              <li>{{ 'home.audience.team.points.2' | translate }}</li>
              <li>{{ 'home.audience.team.points.3' | translate }}</li>
            </ul>
          </div>
        </ng-template>
      </div>

      <div class="audience-visual">
        <img
          *ngIf="activeAudience === 'individual'; else teamAudienceImage"
          src="/assets/home/app-calendar-member.png"
          width="2560"
          height="1600"
          loading="lazy"
          [attr.alt]="'home.audience.image_alt_individual' | translate">
        <ng-template #teamAudienceImage>
          <img
            src="/assets/home/app-team.png"
            width="2560"
            height="1440"
            loading="lazy"
            [attr.alt]="'home.audience.image_alt_team' | translate">
        </ng-template>
      </div>
    </div>
  </section>

  <section class="integration">
    <div class="integration-copy">
      <p class="section-kicker public-page-kicker">{{ 'home.integration.eyebrow' | translate }}</p>
      <h2>{{ 'home.integration.title' | translate }}</h2>
      <p class="integration-copy__lead">{{ 'home.integration.description' | translate }}</p>

      <div class="integration-points">
        <article class="integration-point">
          <h3>{{ 'home.integration.points.1.title' | translate }}</h3>
          <p>{{ 'home.integration.points.1.description' | translate }}</p>
        </article>
        <article class="integration-point">
          <h3>{{ 'home.integration.points.2.title' | translate }}</h3>
          <p>{{ 'home.integration.points.2.description' | translate }}</p>
        </article>
        <article class="integration-point">
          <h3>{{ 'home.integration.points.3.title' | translate }}</h3>
          <p>{{ 'home.integration.points.3.description' | translate }}</p>
        </article>
      </div>

      <div class="integration-code">
        <div class="integration-code__header">
          <span>{{ 'home.integration.code_label' | translate }}</span>
          <span>{{ 'home.integration.code_hint' | translate }}</span>
        </div>
        <pre>&lt;iframe
  src="https://busyguys.com/business-services/42/embed?token=..."
  width="100%"
  height="900"
  style="border:0;"
  loading="lazy"&gt;
&lt;/iframe&gt;</pre>
      </div>
    </div>

    <div class="integration-visual">
      <div class="integration-media">
        <div class="integration-image-card">
          <img src="/assets/home/app-embed-site.png" width="2400" height="1668" loading="lazy" [attr.alt]="'home.integration.image_alt' | translate">
        </div>

        <div class="phone-frame integration-phone">
          <img src="/assets/home/app-embed-site-phone.png" width="780" height="1688" loading="lazy" [attr.alt]="'home.integration.phone_image_alt' | translate">
        </div>
      </div>

      <div class="theme-card">
        <span>{{ 'home.integration.theme_label' | translate }}</span>
        <div class="theme-swatches">
          <i class="theme-swatches__item theme-swatches__item--blue"></i>
          <i class="theme-swatches__item theme-swatches__item--cyan"></i>
          <i class="theme-swatches__item theme-swatches__item--orange"></i>
          <i class="theme-swatches__item theme-swatches__item--slate"></i>
        </div>
        <p>{{ 'home.integration.theme_description' | translate }}</p>
      </div>
    </div>
  </section>

  <section class="faq">
    <div class="section-heading">
      <p class="section-kicker public-page-kicker">{{ 'home.faq.eyebrow' | translate }}</p>
      <h2>{{ 'home.faq.title' | translate }}</h2>
    </div>

    <div class="faq-list">
      <details class="faq-item">
        <summary>{{ 'home.faq.items.1.question' | translate }}</summary>
        <p>{{ 'home.faq.items.1.answer' | translate }}</p>
      </details>
      <details class="faq-item">
        <summary>{{ 'home.faq.items.2.question' | translate }}</summary>
        <p>{{ 'home.faq.items.2.answer' | translate }}</p>
      </details>
      <details class="faq-item">
        <summary>{{ 'home.faq.items.3.question' | translate }}</summary>
        <p>{{ 'home.faq.items.3.answer' | translate }}</p>
      </details>
    </div>
  </section>

  <section class="final-cta">
    <div>
      <h2>{{ 'home.final_cta.title' | translate }}</h2>
      <p>{{ 'home.final_cta.description' | translate }}</p>
    </div>
    <button class="btn btn-primary public-page-button public-page-button--primary" [routerLink]="['/sign-up-business']" type="button">
      {{ 'home.final_cta.button' | translate }}
    </button>
  </section>
</div>
